(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article-premium"]) return;
  try {
    
(() => {
  const root = document.querySelector('[data-gmlx-article]');
  if (!root) return;
  const content = root.querySelector('[data-gmlx-content]');
  const progress = root.querySelector('[data-gmlx-progress]');
  const readtime = root.querySelector('[data-gmlx-readtime]');

  if (content && readtime) {
    const words = (content.textContent || '').trim().split(/\s+/).filter(Boolean).length;
    const minutes = Math.max(1, Math.ceil(words / 210));
    readtime.textContent = minutes + ' min de lectura';
  }

  if (content) {
    const toc = root.querySelector('[data-gmlx-toc]');
    Array.from(content.querySelectorAll('h2')).forEach((heading, index) => {
      if (!heading.id) heading.id = 'seccion-' + (index + 1);
      if (toc) {
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        toc.appendChild(link);
      }
    });
  }

  const updateProgress = () => {
    if (!progress || !content) return;
    const top = content.getBoundingClientRect().top + window.scrollY;
    const end = top + content.offsetHeight - window.innerHeight * 0.3;
    const pct = Math.max(0, Math.min(100, ((window.scrollY - top + window.innerHeight * 0.25) / Math.max(1, end - top)) * 100));
    progress.style.width = pct + '%';
  };
  updateProgress();
  window.addEventListener('scroll', updateProgress, { passive: true });

  const share = root.querySelector('[data-gmlx-share]');
  if (share) {
    share.addEventListener('click', async () => {
      if (navigator.share) {
        try { await navigator.share({ title: document.title, url: window.location.href }); } catch (e) {}
      } else {
        try {
          await navigator.clipboard.writeText(window.location.href);
          share.textContent = 'Enlace copiado ✓';
        } catch (e) {}
      }
    });
  }

  root.querySelectorAll('[data-gmlx-video-toggle]').forEach((button) => {
    const frame = button.closest('.gmlx-funnel__phone');
    const video = frame ? frame.querySelector('[data-gmlx-funnel-video]') : null;
    if (!video) return;
    button.addEventListener('click', () => {
      video.muted = !video.muted;
      if (!video.paused) {
        button.textContent = video.muted ? 'Activar audio' : 'Silenciar';
      } else {
        video.play().catch(() => {});
        button.textContent = video.muted ? 'Activar audio' : 'Silenciar';
      }
    });
  });

  const modal = root.querySelector('[data-gmlx-modal]');
  if (modal && typeof modal.showModal === 'function') {
    const key = 'gmlx_article_consult_seen_v2';
    let allowed = true;
    try {
      const last = Number(localStorage.getItem(key) || 0);
      allowed = !last || Date.now() - last > 7 * 24 * 60 * 60 * 1000;
    } catch (e) {}
    const mark = () => { try { localStorage.setItem(key, String(Date.now())); } catch (e) {} };
    const close = () => { if (modal.open) modal.close(); mark(); };
    root.querySelectorAll('[data-gmlx-close]').forEach((el) => el.addEventListener('click', close));
    const cta = root.querySelector('[data-gmlx-modal-cta]');
    if (cta) cta.addEventListener('click', () => {
      close();
      const target = root.querySelector('#gmlx-funnel-contact');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    modal.addEventListener('click', (event) => { if (event.target === modal) close(); });
    if (allowed) {
      window.setTimeout(() => {
        if (!modal.open && document.visibilityState === 'visible') modal.showModal();
      }, 15000);
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-premium"]) return;
  try {
    
(() => {
  const root = document.querySelector('[data-gml-blog-premium]');
  if (!root) return;
  const modal = root.querySelector('[data-gml-consult-modal]');
  if (!modal || typeof modal.showModal !== 'function') return;
  const key = 'gml_blog_consult_seen_v2';
  const cooldown = 7 * 24 * 60 * 60 * 1000;
  let allowed = true;
  try {
    const last = Number(localStorage.getItem(key) || 0);
    allowed = !last || Date.now() - last > cooldown;
  } catch (e) {}
  const mark = () => { try { localStorage.setItem(key, String(Date.now())); } catch (e) {} };
  const close = () => { if (modal.open) modal.close(); mark(); };
  root.querySelectorAll('[data-gml-modal-close]').forEach((el) => el.addEventListener('click', close));
  const cta = root.querySelector('[data-gml-modal-cta]');
  if (cta) cta.addEventListener('click', () => {
    close();
    const target = root.querySelector('#gml-blog-consultoria');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  modal.addEventListener('click', (event) => { if (event.target === modal) close(); });
  if (allowed) window.setTimeout(() => {
    if (!modal.open && document.visibilityState === 'visible') modal.showModal();
  }, 15000);
})();

  } catch(e) { console.error(e); }
})();
})();
